import { Location } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, effect, inject, input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router, RouterModule } from '@angular/router';

import { ActivityStream } from '@lib/activity-stream';
import { ClientForm } from '@lib/client-form';

import { Auth, Lambda } from '../service';
import { ClientService } from '../service/client';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ActivityStream,
    MatIconModule,
    MatTooltipModule,
    MatButtonModule,
    MatToolbarModule,
    MatTableModule,
    MatListModule,
    MatProgressSpinnerModule,
    RouterModule,
  ],
  templateUrl: './client-detail-page.html',
})
export class ClientDetailPage {
  canEdit = inject(Auth).isAdminOrEditor();

  private location = inject(Location);

  private dialog = inject(MatDialog);

  private router = inject(Router);

  private clientService = inject(ClientService);

  kbLink = inject(Lambda).getKnowledgeBaseLink();

  pending = this.clientService.pending;

  clientCode = input.required<string>();

  client = computed(() => this.clientService.clients().find((it) => it.ClientCode === this.clientCode()));

  _ = effect(() => {
    if (!this.client() && !this.pending()) {
      this.router.navigate(['/404']);
    }
  });
  edit() {
    const client = this.client();
    if (!client) {
      console.warn('Attempt to open edit form without a client');
      return;
    }

    this.dialog
      .open(ClientForm, {
        data: { client },
      })
      .afterClosed()
      .subscribe((result) => result && this.clientService.reload());
  }

  back() {
    this.location.back();
  }
}
